import type { KeyValueStorage } from '@alternativamais/chat-core';

/**
 * `localStorage` para o core (rascunhos, fila de envio) e para as
 * preferências da tela. Pode faltar (aba anônima, bloqueio): tudo funciona
 * sem ele, só não guarda.
 */
export const armazenamentoLocal: KeyValueStorage = {
  getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // cheio ou bloqueado: segue sem guardar
    }
  },
  removeItem(key) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // idem
    }
  },
};

const PREFIXO = 'chat:tela:';

export function lerPreferencia<T>(chave: string, padrao: T): T {
  const bruto = armazenamentoLocal.getItem(PREFIXO + chave);
  if (typeof bruto !== 'string') return padrao;
  try {
    return JSON.parse(bruto) as T;
  } catch {
    return padrao;
  }
}

export function gravarPreferencia(chave: string, valor: unknown): void {
  void armazenamentoLocal.setItem(PREFIXO + chave, JSON.stringify(valor));
}
